import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private loader = inject(LoaderService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skip = request.headers.has('X-Skip-Loader');
    if (!skip) { this.loader.showLoader(); }
    // Client-side flag only — strip it so the API never sees (or CORS-rejects) it.
    else { request = request.clone({ headers: request.headers.delete('X-Skip-Loader') }); }
    return next.handle(request).pipe(
      finalize(() => { if (!skip) { this.loader.hideLoader(); } })
    );
  }
}
